export const TradingPreferencesRoutes = {
    ROOT: "/trading-preferences",
    SUMMARY: "/trading-preferences/summary",
    SIGNING: "/trading-preferences/signing",
    SUCCESS: "/trading-preferences/success",
};



// WEBPACK FOOTER //
// ./src/components/tradingPreferences/TradingPreferencesRoutes.ts